import OrderAction from './orderAction';
import { isValidEmail } from './utils';

export default class SendPaymentInstructionAction extends OrderAction {
    static NAME = 'send_payment_instruction';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    //for send => only reserved , not deleted and buyer_email and not invitation
    static condition(order) {
        return (
            ['reservation'].includes(order.status) &&
            order.attendee_count > order.attendees_deleted_count &&
            isValidEmail(order.buyer_email) &&
            order.origin !== 'weez_invitation' &&
            super.payment_plan_condition(order)
        );
    }

    static is_available({ feature_flags, event }) {
        return !feature_flags.includes('EO_FREE') && !['over', 'closed'].includes(event.status) && !event.removed;
    }

    get needs_selection() {
        return false;
    }

    get needs_confirm() {
        return true;
    }
}
